import { lazy } from 'react'
import { createBrowserRouter, redirect } from 'react-router-dom'

import { AuthLayout } from './layouts/AuthLayout'
import { AppLayout } from './layouts/AppLayout'
import { RouteErrorBoundary } from './ErrorBoundary'
import { authGuard } from './guards/authGuard'
import { roleGuard } from './guards/roleGuard'

import { EmailLogin } from '@/pages/auth/EmailLogin'
import { Login } from '@/pages/auth/Login'
import { OAuthCallback } from '@/pages/auth/OAuthCallback'
import { Forbidden } from '@/pages/error/Forbidden'
import { NotFound } from '@/pages/error/NotFound'

const Workbench = lazy(() => import('@/pages/workbench/Workbench'))
const History = lazy(() => import('@/pages/workbench/History'))
const Palettes = lazy(() => import('@/pages/workbench/Palettes'))
const Compare = lazy(() => import('@/pages/workbench/Compare'))
const Library = lazy(() => import('@/pages/library/Library'))
const ProductDetail = lazy(() => import('@/pages/library/ProductDetail'))
const Profile = lazy(() => import('@/pages/settings/Profile'))
const UserManagement = lazy(() => import('@/pages/admin/UserManagement'))
const ProductLibraryManagement = lazy(() => import('@/pages/admin/ProductLibraryManagement'))
const Dashboard = lazy(() => import('@/pages/analytics/Dashboard'))

export const router = createBrowserRouter([
  {
    element: <AuthLayout />,
    children: [
      { path: '/login', element: <Login /> },
      { path: '/login/email', element: <EmailLogin /> },
    ],
  },
  { path: '/oauth/callback', element: <OAuthCallback /> },
  { path: '/403', element: <Forbidden /> },
  { path: '/404', element: <NotFound /> },
  {
    element: <AppLayout />,
    loader: authGuard,
    errorElement: <RouteErrorBoundary />,
    children: [
      { index: true, loader: () => redirect('/workbench') },
      { path: 'workbench', element: <Workbench /> },
      { path: 'history', element: <History /> },
      { path: 'palettes', element: <Palettes /> },
      { path: 'compare', element: <Compare /> },
      { path: 'library', element: <Library /> },
      { path: 'library/:id', element: <ProductDetail /> },
      { path: 'settings', element: <Profile /> },
    ],
  },
  {
    element: <AppLayout sidebar />,
    loader: authGuard,
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        path: 'admin',
        loader: roleGuard(['ADMIN']),
        children: [
          { index: true, loader: () => redirect('/admin/users') },
          { path: 'users', element: <UserManagement /> },
          {
            path: 'products',
            loader: roleGuard(['ADMIN']),
            element: <ProductLibraryManagement />,
          },
        ],
      },
      {
        path: 'analytics',
        loader: roleGuard(['ADMIN']),
        element: <Dashboard />,
      },
    ],
  },
  { path: '*', element: <NotFound /> },
])
